import React, { useState } from "react";

// Copy-to-clipboard button. Rendered next to text that is already on the page
// (a citation, a URL), so without JavaScript the text is still there to select.
export default function CopyText({ text, label = "Copy" }) {
	const [copied, setCopied] = useState(false);

	async function copy() {
		try {
			await navigator.clipboard.writeText(text);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch (e) {
			console.error("Clipboard write failed:", e);
		}
	}

	return (
		<button type="button" onClick={copy} className="text-sm font-medium text-ink-muted underline decoration-accent-soft underline-offset-4 hover:text-ink">
			{copied ? "Copied" : label}
		</button>
	);
}
